import { render, staticRenderFns } from "./shopAssistant.vue?vue&type=template&id=7bc14330&scoped=true&"
import script from "./shopAssistant.vue?vue&type=script&lang=js&"
export * from "./shopAssistant.vue?vue&type=script&lang=js&"
import style0 from "./shopAssistant.vue?vue&type=style&index=0&id=7bc14330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc14330",
  null
  
)

export default component.exports